import {
  Autocomplete,
  CircularProgress,
  TextField,
  TextFieldProps,
} from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { DismissalType } from "services/KnowfullyAdminClient";

type SelectDismissalTypeProps = {
  value?: number;
  onChange: (id: number | undefined) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  textFieldProps?: Partial<TextFieldProps>;
};

const SelectDismissalType = ({
  value,
  onChange,
  label,
  disabled,
  required,
  error,
  textFieldProps,
}: SelectDismissalTypeProps) => {
  const { formatMessage: t } = useIntl();
  const { notificationsConfigurationsService } = useGlobalContext();

  const { data, isLoading } = useQuery(
    ["notificationsConfigurationsService.getDismissalTypes"],
    () => notificationsConfigurationsService.getDismissalTypes(),
  );

  const options = (data?.data ?? []) as DismissalType[];
  const selectedOption = options.find((o) => o.id === value) ?? null;

  return (
    <Autocomplete<DismissalType>
      value={selectedOption}
      onChange={(_event, newValue) => onChange(newValue?.id)}
      options={options}
      loading={isLoading}
      disabled={disabled || isLoading}
      getOptionLabel={(option) => option.name || ""}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          variant="standard"
          label={label || t({ id: "dismissal" })}
          required={required}
          error={error}
          InputProps={{
            ...params.InputProps,
            startAdornment: isLoading && <CircularProgress size={16} />,
          }}
        />
      )}
    />
  );
};

export default SelectDismissalType;
